import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "@xo-union/tk-css-grid/lib/styles.css";
import TopLevelContainer from "../TopLevelContainer/index.js";
import Row from "../Row/index.js";
import Column from "../Column/index.js";
const MainContentColumn = _ref => {
  let {
    children,
    classes: classesProp
  } = _ref;
  const classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(Column, {
    className: classes['main-content-column']
  }, children);
};
process.env.NODE_ENV !== "production" ? MainContentColumn.propTypes = {
  children: PropTypes.node.isRequired,
  classes: classesPropType(['main-content-column'])
} : void 0;
const StickyLeftColumn = _ref2 => {
  let {
    children,
    classes: classesProp
  } = _ref2;
  const classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(Column, {
    as: "aside",
    className: classes['sticky-left-column']
  }, children);
};
process.env.NODE_ENV !== "production" ? StickyLeftColumn.propTypes = {
  children: PropTypes.node.isRequired,
  classes: classesPropType(['sticky-left-column'])
} : void 0;
const ContainerWithStickyColumn = _ref3 => {
  let {
    as: ComponentToRender,
    classes,
    stickyColumnContent,
    mainContent,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(TopLevelContainer, _extends({
    as: ComponentToRender,
    classes: classes
  }, rest), /*#__PURE__*/React.createElement(Row, {
    hGutters: false
  }, /*#__PURE__*/React.createElement(StickyLeftColumn, {
    classes: classes
  }, stickyColumnContent), /*#__PURE__*/React.createElement(MainContentColumn, {
    classes: classes
  }, mainContent)));
};
process.env.NODE_ENV !== "production" ? ContainerWithStickyColumn.propTypes = {
  /**
   * Component to render in place of the TopLevelContainer (e.g. "section")
   */
  as: PropTypes.elementType,
  /**
   * content for the sticky left-aligned column
   */
  stickyColumnContent: PropTypes.node.isRequired,
  /**
   * Class dependencies
   */
  classes: classesPropType(['main-content-column', 'sticky-left-column', 'top-level-container']),
  /**
   * content for the main content area to the right of the sticky column. If using a subgrid, should have a Row at the top.
   */
  mainContent: PropTypes.node.isRequired
} : void 0;
ContainerWithStickyColumn.defaultProps = {
  as: 'div'
};
export default ContainerWithStickyColumn;